import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { emptyServerInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";
import { buildProfileActivityForPlayer } from "#/server/game/profileActivity.server";

export type ProfileActivityDay = {
  date: string | null;
  standardCompleted: boolean;
  premiumCompleted: boolean;
};

export type ProfileActivityWeek = {
  weekMonday: string;
  challengeCompleted: boolean | null;
  days: ProfileActivityDay[];
};

export type ProfileActivityData = {
  todayStr: string;
  weeks: ProfileActivityWeek[];
};

export const loadProfileActivity = createServerFn({ method: "GET" })
  .middleware([authedMiddleware])
  .validator(emptyServerInputSchema)
  .handler(async ({ context }) => {
    setRouteAction("profile_activity");
    return buildProfileActivityForPlayer(context.userId);
  });
